<template>
    <div class="cost-invoice-page max-content">
        <van-nav-bar title="劳务费信息与发票" fixed placeholder :border="true" />
        <img class="banner-img"
            src="https://cdn.edstatic.com/202702011646/4bbf11efbaafa651d21fbd5229b060f6/2026/08/05/5e68ba1c334c9623e54b18e86bb964ab225ee4fa.jpg"
            alt="">
        <div class="page-body">
            <!-- 劳务费信息 -->
            <div class="section">
                <div class="section-title">
                    <span class="bar"></span>
                    <span>劳务费信息</span>
                </div>
                <div class="fee-card">
                    <p class="fee-label">您的劳务费金额（税前）</p>
                    <p class="fee-amount">¥{{ formattedAmount }}</p>
                    <div class="fee-notice">
                        <svg class="bulb-icon" viewBox="0 0 24 24" width="14" height="14">
                            <path fill="currentColor"
                                d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7z" />
                        </svg>
                        <span>此金额由会议主办方核定，不可修改</span>
                    </div>
                </div>
            </div>
            <!-- 收款信息表单 -->
            <div class="form-card">
                <van-form ref="payForm" input-align="right" error-message-align="right">
                    <van-field v-model="form.username" name="姓名" label="姓名" placeholder="请输入真实姓名"
                        :disabled="paymentSubmitted" :rules="[{ required: true, message: '请输入真实姓名' }]" />
                    <van-field v-model="form.mobile" name="手机号" label="手机号" type="tel" maxlength="11" readonly
                        placeholder="请输入11位手机号" disabled :rules="[
                            { required: true, message: '请输入手机号' },
                            { pattern: /^1\d{10}$/, message: '请输入正确的手机号' }
                        ]" />
                    <van-field v-model="form.idcard_number" name="身份证号" label="身份证号" maxlength="18"
                        placeholder="请输入18位身份证号" :disabled="paymentSubmitted" :rules="[
                            { required: true, message: '请输入身份证号' },
                            { pattern: /(^\d{15}$)|(^\d{17}[\dXx]$)/, message: '请输入正确的身份证号' }
                        ]" />
                    <van-field v-model="form.bank_number" name="银行账号" label="银行账号" type="digit" placeholder="请输入银行卡号"
                        :disabled="paymentSubmitted" :rules="[{ required: true, message: '请输入银行卡号' }]" />
                    <van-field v-model="form.bank_name" name="开户行" label="开户行" placeholder="如：招商银行"
                        :disabled="paymentSubmitted" :rules="[{ required: true, message: '请输入开户行' }]" />
                    <van-field v-model="form.bank_branch_name" name="支行" label="支行" placeholder="如：北京分行中关村支行"
                        :disabled="paymentSubmitted" :rules="[{ required: true, message: '请输入支行' }]" />
                </van-form>
            </div>

            <div class="btn-wrap">
                <button class="action-btn" :class="{ disabled: paymentSubmitted || paySubmitting }"
                    :disabled="paymentSubmitted || paySubmitting" @click="onSubmitPayment">
                    提交收款信息
                </button>
            </div>

            <!-- 分隔线 -->
            <div class="divider">
                <span class="line"></span>
                <span class="dot"></span>
                <span class="line"></span>
            </div>

            <!-- 上传发票 -->
            <div class="section">
                <div class="section-title">
                    <span class="bar"></span>
                    <span>上传发票</span>
                </div>

                <div class="tips-card">
                    <div class="tips-title">
                        <span class="info-icon">i</span>
                        <span>上传须知</span>
                    </div>
                    <ul class="tips-list">
                        <li>请上传与劳务费金额一致的发票</li>
                        <li>支持 JPG、PNG、PDF 格式，单个文件不超过 10MB</li>
                        <li>发票需清晰完整，包含发票代码、金额等关键信息</li>
                        <li>如已开具电子发票，请上传原件截图</li>
                        <li>发票开具最晚日期为2026年11月15日，超过此日期视为放弃领取劳务费</li>
                        <li>如有问题，可以联系乔莹16600089580（同微信）</li>
                    </ul>
                    <a class="invoice-guide-link" href="https://cdn.edstatic.com/203012120000/0ad9e37eb5ba8a9c60e40a1769686d4c/2026/08/4b2e1395-8db0-474f-9de4-d55d1bbcf995.pdf" target="_blank">
                        <van-icon name="description" color="#C9A03C" size="20" />
                        <span>查看开票流程指引（PDF）</span>
                        <van-icon name="arrow" color="#C9A03C" size="20" />
                    </a>
                </div>

                <div class="upload-area">
                    <van-uploader v-model="fileList" :max-count="1" :max-size="10 * 1024 * 1024"
                        accept="image/jpeg,image/png,application/pdf,.jpg,.jpeg,.png,.pdf" :after-read="afterRead"
                        :before-delete="beforeDelete" :disabled="invoiceSubmitted" :deletable="!invoiceSubmitted"
                        @oversize="onOversize">
                        <div class="upload-trigger" v-if="!fileList.length">
                            <div class="upload-icon">
                                <svg viewBox="0 0 24 24" width="28" height="28">
                                    <path fill="#fff" d="M9 16h6v-6h4l-7-7-7 7h4v6zm-4 2h14v2H5v-2z" />
                                </svg>
                            </div>
                            <p class="upload-main">点击上传发票</p>
                            <p class="upload-sub">支持 JPG / PNG / PDF 格式</p>
                        </div>
                    </van-uploader>
                </div>
            </div>

            <div class="btn-wrap btn-wrap-bottom">
                <button class="action-btn" :class="{ disabled: invoiceSubmitted || invoiceSubmitting }"
                    :disabled="invoiceSubmitted || invoiceSubmitting" @click="onSubmitInvoice">
                    提交发票
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { PersoanalUserInfo, uploadImg, UserLabour, UserLabourInvoice } from '../../../config/interface.js'

export default {
    data() {
        return {
            meeting_id: this.$route.query.meeting_id || this.$route.query.id || '',
            amount: Number(this.$route.query.amount) || 5000,
            form: {
                username: '',
                mobile: '',
                idcard_number: '',
                bank_number: '',
                bank_name: '',
                bank_branch_name: ''
            },
            baseInfo: {},
            fileList: [],
            invoice_url: '',
            paymentSubmitted: false,
            invoiceSubmitted: false,
            paySubmitting: false,
            invoiceSubmitting: false
        }
    },
    computed: {
        formattedAmount() {
            const num = Number(this.baseInfo.pre_tax_amount) || 0
            return num.toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        }
    },
    created() {
        document.title = '劳务费信息与发票'
        this.getUserInfo()
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1)
        },
        getUserInfo() {
            const url = PersoanalUserInfo
            fetch(url, {}, 'POST').then((res) => {
                if (res.code == 0) {
                    const data = res.data
                    localStorage.setItem('userInfo', JSON.stringify(data))
                    this.$store.dispatch('storageUserInfo', data)
                    if (data && data.mobile_status == 1) {
                        this.form.mobile = data.mobile || ''
                        if (data.realname) {
                            this.form.username = data.realname
                        }
                        this.getUserLabour()
                    } else {
                        common.toast('未绑定手机', 1000, 'fail', () => {
                            this.$router.replace({
                                path: '/vascularNews/user/login',
                                query: {
                                    meeting_id: this.meeting_id,
                                    url: window.location.href
                                }
                            })
                        })
                    }
                }
            })
        },
        //获取基础信息
        getUserLabour() {
            fetch(UserLabour, {
                meeting_id: this.meeting_id
            }, 'GET').then((res) => {
                if (res.code == 0 && res.data) {
                    this.baseInfo = res.data
                    this.form.mobile = this.baseInfo.mobile || this.form.mobile || ''
                    this.form.username = this.baseInfo.username || ''
                    this.form.idcard_number = this.baseInfo.idcard_number || ''
                    this.form.bank_number = this.baseInfo.bank_number || ''
                    this.form.bank_name = this.baseInfo.bank_name || ''
                    this.form.bank_branch_name = this.baseInfo.bank_branch_name || ''
                    // 已提交过收款信息：刷新后仍锁定表单
                    // if (this.baseInfo.username && this.baseInfo.idcard_number && this.baseInfo.bank_number) {
                    //     this.paymentSubmitted = true
                    // }
                    // if (this.baseInfo.invoice) {
                    //     this.invoice_url = this.baseInfo.invoice
                    //     this.fileList = [{ url: this.baseInfo.invoice, isImage: true }]
                    //     this.invoiceSubmitted = true
                    // }
                }
            })
        },
        onSubmitPayment() {
            if (this.paymentSubmitted || this.paySubmitting) return
            this.$refs.payForm.validate().then(() => {
                this.paySubmitting = true
                const params = {
                    meeting_id: this.meeting_id,
                    username: this.form.username,
                    mobile: this.form.mobile,
                    idcard_number: this.form.idcard_number,
                    bank_number: this.form.bank_number,
                    bank_name: this.form.bank_name,
                    bank_branch_name: this.form.bank_branch_name
                }
                fetch(UserLabour, params, 'POST').then((res) => {
                    this.paySubmitting = false
                    if (res.code == 0) {
                        this.paymentSubmitted = true
                        common.toast('收款信息提交成功', 1000, 'success')
                    }
                }).catch(() => {
                    this.paySubmitting = false
                })
            }).catch(() => { })
        },
        afterRead(file) {
            file.status = 'uploading'
            file.message = '上传中...'
            const formData = new FormData()
            formData.append('file', file.file)
            fetch(uploadImg, formData, 'POST').then((res) => {
                if (res.code == 0) {
                    file.status = 'done'
                    file.message = ''
                    this.invoice_url = res.data.path || res.data.url || ''
                    if (res.data.url) {
                        file.url = res.data.url
                    }
                } else {
                    file.status = 'failed'
                    file.message = '上传失败'
                    this.invoice_url = ''
                }
            }).catch(() => {
                file.status = 'failed'
                file.message = '上传失败'
                this.invoice_url = ''
            })
        },
        beforeDelete() {
            this.invoice_url = ''
            return true
        },
        onOversize() {
            common.toast('单个文件不能超过 10MB', 1500, 'fail')
        },
        onSubmitInvoice() {
            // if (this.invoiceSubmitted || this.invoiceSubmitting) return
            // if (!this.paymentSubmitted) {
            //     common.toast('请先提交收款信息', 1500, 'fail')
            //     return
            // }
            if (!this.invoice_url && !this.fileList.length) {
                common.toast('请上传发票', 1500, 'fail')
                return
            }
            if (this.fileList[0] && this.fileList[0].status === 'uploading') {
                common.toast('发票上传中，请稍候', 1500, 'fail')
                return
            }
            if (this.fileList[0] && this.fileList[0].status === 'failed') {
                common.toast('发票上传失败，请重新上传', 1500, 'fail')
                return
            }
            if (!this.invoice_url) {
                common.toast('请上传发票', 1500, 'fail')
                return
            }
            this.invoiceSubmitting = true
            const params = {
                meeting_id: this.meeting_id,
                invoice: this.invoice_url
            }
            fetch(UserLabourInvoice, params, 'POST').then((res) => {
                this.invoiceSubmitting = false
                if (res.code == 0) {
                    this.invoiceSubmitted = true
                    common.toast('发票提交成功', 1000, 'success')
                }
            }).catch(() => {
                this.invoiceSubmitting = false
            })
            { }
        }
    }
}
</script>

<style lang="scss" scoped>
$gold: #A68523;
$gold-dark: #C9A03C;
$btn-bg: #a9b7c1;
$btn-text: #5f6f7c;
$page-bg: #ffffff;

.cost-invoice-page {
    min-height: 100vh;
    background: $page-bg;
    padding-bottom: 30px;

    /deep/ .van-nav-bar {
        background: #fff;
        z-index: 9;

        .van-nav-bar__title {
            color: #1a1a1a;
            font-weight: 600;
            font-size: 17px;
        }

        .van-icon {
            color: #333;
        }
    }

    /deep/ .van-hairline--bottom::after {
        border-bottom-color: #eee;
    }
}

.banner-img {
    width: 100%;
    height: auto;
}

.page-body {
    padding: 16px 16px 0;
}

.section-title {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    color: #C9A03C;
    font-size: 16px;
    font-weight: 600;

    .bar {
        display: inline-block;
        width: 4px;
        height: 16px;
        margin-right: 8px;
        border-radius: 2px;
        background: $gold;
    }
}

.fee-card {
    padding: 22px 18px 16px;
    border-radius: 14px;
    border: 1px solid rgba(197, 200, 203, 0.6);
    background: linear-gradient(145deg, #F4F5F7 0%, #D8DADD 40%, #C5C8CB 100%);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.06);
    position: relative;

    .fee-label {
        margin: 0;
        color: #C9A03C;
        font-size: 13px;
    }

    .fee-amount {
        margin: 10px 0 16px;
        color: $gold;
        font-size: 36px;
        font-weight: 700;
        line-height: 1.2;
        letter-spacing: 0.5px;
    }

    .fee-notice {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        border-radius: 8px;
        background: rgba(201, 160, 60, 0.08);
        border: 1px solid rgba(201, 160, 60, 0.15);
        color: $gold;
        font-size: 12px;
        line-height: 1.4;

        .bulb-icon {
            flex-shrink: 0;
            margin-right: 6px;
            color: $gold;
        }
    }
}

.fee-card::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: repeating-linear-gradient(110deg, transparent 0px, transparent 18px, rgba(255, 255, 255, 0.15) 18px, rgba(255, 255, 255, 0.15) 19px);
    pointer-events: none;
}

.fee-card>* {
    position: relative;
    z-index: 1;
}

.fee-card::before {
    content: '';
    position: absolute;
    top: -40%;
    left: 10%;
    width: 300px;
    height: 200px;
    background: radial-gradient(ellipse, rgba(255, 255, 255, 0.55) 0%, transparent 70%);
    pointer-events: none;
}

.form-card {
    margin-top: 16px;
    overflow: hidden;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 2px 12px rgba(30, 42, 50, 0.06);
    border: 1px solid rgba(216, 224, 230, 0.5);

    /deep/ .van-cell {
        padding: 14px 16px;
        font-size: 15px;
        line-height: 24px;
    }

    /deep/ .van-field__label {
        color: #333;
        width: 5.2em;
    }

    /deep/ .van-field__control {
        color: #333;
    }

    /deep/ .van-field__control::placeholder {
        color: #c8c9cc;
    }

    /deep/ .van-cell::after {
        border-bottom-color: #f0f0f0;
        right: 16px;
        left: 16px;
    }

    /deep/ .van-hairline--top-bottom::after,
    /deep/ .van-hairline-unset--top-bottom::after {
        border: none;
    }
}

.btn-wrap {
    margin: 24px 4px 8px;

    &.btn-wrap-bottom {
        margin-top: 28px;
        margin-bottom: 20px;
    }
}

.action-btn {
    display: block;
    width: 100%;
    height: 46px;
    border: none;
    border-radius: 23px;
    background: linear-gradient(135deg, #C2CCD2 0%, #9CADB8 50%, #7A8C98 100%);
    box-shadow: 0 4px 10px rgba(154, 171, 186, 0.35);
    color: #5A6E7A;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 1px;
    outline: none;
    -webkit-appearance: none;
    appearance: none;

    &:active:not(.disabled) {
        opacity: 0.9;
    }

    &.disabled {
        opacity: 0.75;
        color: rgba(255, 255, 255, 0.85);
    }
}

.divider {
    display: flex;
    align-items: center;
    margin: 20px 0 24px;
    padding: 0 8px;

    .line {
        flex: 1;
        height: 1px;
        background: #e5e5e5;
    }

    .dot {
        width: 8px;
        height: 8px;
        margin: 0 12px;
        border-radius: 50%;
        background: $gold;
        flex-shrink: 0;
    }
}

.tips-card {
    padding: 14px 16px;
    margin-bottom: 16px;
    border-radius: 12px;
    background: linear-gradient(145deg, #F8F8F9 0%, #EDEEF0 40%, #E0E2E5 100%);

    .tips-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        color: $gold;
        font-size: 14px;
        font-weight: 600;

        .info-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 16px;
            height: 16px;
            margin-right: 6px;
            border-radius: 50%;
            border: 1.5px solid $gold;
            font-size: 11px;
            font-style: italic;
            font-weight: 700;
            line-height: 1;
        }
    }

    .tips-list {
        margin: 0;
        padding: 0;
        list-style: none;

        li {
            position: relative;
            padding-left: 12px;
            margin-bottom: 6px;
            color: #8B7025;
            font-size: 12px;
            line-height: 1.55;

            &:last-child {
                margin-bottom: 0;
            }

            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 7px;
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background: $gold;
            }
        }
    }

    .invoice-guide-link {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 12px;
        padding: 10px 14px;
        background: rgba(201, 160, 60, 0.1);
        border: 1px solid rgba(201, 160, 60, 0.25);
        border-radius: 10px;
        text-decoration: none;
        transition: all 0.2s ease;
        cursor: pointer;
        color: #8B6914;
        font-weight: 500;
        font-size: 13px;

        span{
            flex:1;
        }
    }
}

.upload-area {
    /deep/ .van-uploader {
        width: 100%;
        display: block;
    }

    /deep/ .van-uploader__wrapper {
        width: 100%;
        display: block;
    }

    /deep/ .van-uploader__input-wrapper {
        width: 100%;
        display: block;
    }

    /deep/ .van-uploader__preview {
        width: 100%;
        margin: 0;
    }

    /deep/ .van-uploader__preview-image {
        width: 100%;
        height: 180px;
        border-radius: 14px;
        object-fit: contain;
        background: #fafafa;
    }

    /deep/ .van-uploader__preview-delete {
        top: 6px;
        right: 6px;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /deep/ .van-uploader__preview-delete-icon {
        position: static;
        top: auto;
        right: auto;
        font-size: 16px;
        line-height: 1;
        transform: none;
    }
}

.upload-trigger {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 180px;
    padding: 28px 16px;
    box-sizing: border-box;
    border: 1.5px dashed #d0d0d0;
    border-radius: 14px;
    background:
        radial-gradient(ellipse at 30% 40%, rgba(184, 147, 72, 0.06) 0%, transparent 50%),
        radial-gradient(ellipse at 70% 60%, rgba(184, 147, 72, 0.05) 0%, transparent 45%),
        #fafafa;

    .upload-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 52px;
        height: 52px;
        margin-bottom: 14px;
        border-radius: 12px;
        background: linear-gradient(180deg, #c9a45a 0%, $gold 100%);
        box-shadow: 0 4px 10px rgba(184, 147, 72, 0.35);
    }

    .upload-main {
        margin: 0 0 6px;
        color: #222;
        font-size: 15px;
        font-weight: 600;
    }

    .upload-sub {
        margin: 0;
        color: #999;
        font-size: 12px;
    }
}

.van-field--disabled /deep/ .van-field__label {
    color: #333 !important;
}

/deep/ .van-field__control:disabled {
    -webkit-text-fill-color: #999;
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/CostAndInvoice/info.vue